export default __webpack_public_path__ + "static/media/icon-loon-logo.bc502c06.svg";